import {
    APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS,
    PROVIDER_EXPERIENCE_IS_LOADING,
} from "../../actions/actionTypes";
import { buildProviderExperiencePayload } from "@src/apps/PEM/GlobalFilters/services/filterStateManager";
import { getDefaultProviderExperienceFilters } from "@src/apps/PEM/GlobalFilters/services/filterStateManager";
import { getGeoCriteria } from '@src/utility/storage.service.helpers';

interface PemDetailsState {
    filterPayload: object;
    isLoading: boolean;
    error: string | null;
}

// Get all default filters from session (timePeriod, lob, taxId, region, states, markets, etc.)
const defaultFilters = getDefaultProviderExperienceFilters();
const isGeoFlow = Boolean(getGeoCriteria());
const initialFilterPayload = buildProviderExperiencePayload({}, defaultFilters, isGeoFlow);

const initialState: PemDetailsState = {
    filterPayload: initialFilterPayload,
    isLoading: false,
    error: null
};

const PemDetailsReducer = (state = initialState, action: { type: string; payload?: any }): PemDetailsState => {
    switch (action.type) {
        case APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS:
            if (typeof action.payload === 'object' && action.payload !== null) {
                return {
                    ...state,
                    filterPayload: { ...state.filterPayload, ...action.payload }
                };
            }
            return {
                ...state,
                filterPayload: { ...state.filterPayload, lineOfBusiness: action.payload }
            };
        case PROVIDER_EXPERIENCE_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        default:
            return state;
    }
};

export default PemDetailsReducer;